import { use, useCallback } from "react";

import { ScrollContext } from "$src/core/contexts/scroll";

const useScroll = () => {
  const { scrollRef } = use(ScrollContext) ?? {};

  const scrollToTop = useCallback(() => {
    if (!scrollRef?.current) return;

    if ("scrollTo" in scrollRef.current) {
      scrollRef.current.scrollTo({ y: 0, animated: true });
    } else if ("scrollToIndex" in scrollRef.current) {
      scrollRef.current.scrollToIndex({ index: 0, animated: true });
    } else if ("scrollToLocation" in scrollRef.current) {
      // `scrollToLocation` stops below the `ListHeaderComponent`, not at offset 0.
      const responder =
        "getScrollResponder" in scrollRef.current
          ? scrollRef.current.getScrollResponder()
          : undefined;
      if (responder) {
        responder.scrollTo({ y: 0, animated: true });
        return;
      }
      scrollRef.current.scrollToLocation({
        itemIndex: 0,
        sectionIndex: 0,
        animated: true,
      });
    }
  }, [scrollRef]);

  return {
    scrollRef,
    scrollToTop,
  };
};

export default useScroll;
